import * as React from "react";
import type { SVGProps } from "react";
const SvgQuestionMarkInCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.99 15c-.55 0-1-.45-1-1v-1.32c0-.55.46-1 1.01-1 .49 0 .95-.19 1.3-.54s.54-.81.54-1.3-.19-.95-.54-1.3c-.7-.7-1.91-.69-2.6 0a.996.996 0 1 1-1.41-1.41c1.45-1.45 3.98-1.45 5.43 0 .73.73 1.12 1.69 1.12 2.72s-.4 1.99-1.12 2.72c-.48.48-1.07.82-1.71 1v.45c0 .55-.45 1-1 1zM12 18c-.26 0-.52-.11-.71-.29l-.12-.15a.8.8 0 0 1-.09-.18.6.6 0 0 1-.06-.18 1 1 0 0 0-.01-.1q-.009-.049-.01-.1c0-.13.03-.26.08-.38q.075-.18.21-.33c.37-.37 1.05-.37 1.42 0q.135.15.21.33c.06.12.08.25.08.38 0 .07 0 .13-.02.2 0 .06-.03.12-.06.18a.8.8 0 0 1-.168.28l-.042.05c-.19.18-.45.29-.71.29"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12c0 5.51 4.49 10 10 10s10-4.49 10-10S17.51 2 12 2 2 6.49 2 12m2 0c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8-8-3.59-8-8"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgQuestionMarkInCircle;
